import React, { useState, useEffect, useMemo, useCallback } from "react";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import { firebaseConfig } from "../firebase/firebaseConfig";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import MerciaChat from "../components/MerciaChat"; // 🔹 Importando o chatbot

import Profile from "./Profile";
import Dashboard from "./Dashboard/Dashboard";
import Login from "./Login";
import Reports from "./Reports";
import SubscriptionManager from "./Subscriptions/SubscriptionManager";
import Settings from "./Settings"; // 🔹 Certifique-se de que o caminho está correto

//import WelcomeContent from "../components/WelcomeContent";
//


import "../styles/Portal.css";

// Inicializar Firebase apenas uma vez
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}
const auth = firebase.auth();

const Portal = () => {
  console.log("Portal componente renderizado"); // Log para monitorar renderizações principais

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState("welcome");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Alternar visibilidade do Sidebar
  const toggleSidebar = () => {
    console.log("Toggle Sidebar chamado");
    setIsSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    console.log("useEffect: Monitorando autenticação");
  
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      console.log("Usuário autenticado:", currentUser);
      setUser(currentUser);
      setLoading(false);
    });
  
    return () => {
      console.log("useEffect: Limpando autenticação");
      unsubscribe();
    };
  }, []);
  

  const navigateTo = useCallback(
    (route) => {
      console.log(`Mudando para a rota: ${route}`);
  
      // Fecha o Sidebar antes de mudar a rota
      setIsSidebarOpen(false);
  
      if (route !== content) {
        setContent(route);
      } else {
        console.log(`Rota ${route} já está ativa.`);
      }
    },
    [content]
  );
  
  const renderContent = useMemo(() => {
    console.log(`Renderizando conteúdo: ${content}`);
    switch (content) {
      case "profile":
        return <Profile user={user} onNavigate={navigateTo} />;
      case "dashboard":
        return <Dashboard user={user} onNavigate={navigateTo} />;
      case "reports":
        return <Reports />; 
      case "SubscriptionManager":
        return <SubscriptionManager user={user} onNavigate={navigateTo} />;
      case "Settings": // 🔹 Adicionando a página de Configurações
        return <Settings user={user} onNavigate={navigateTo} />;
      default:
        return <Profile user={user} onNavigate={navigateTo} />; // ✅ Corrigido aqui
      }
  }, [content, user, navigateTo]); // ✅ Adicionado navigateTo

  const handleLogin = async (email, password) => {
    console.log("handleLogin chamado");
    try {
      setLoading(true);
      await auth.signInWithEmailAndPassword(email, password);
    } catch (error) {
      console.error("Erro ao autenticar:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    console.log("handleLogout chamado");
    try {
      await auth.signOut();
      setUser(null);
      setContent("welcome");
    } catch (error) {
      console.error("Erro ao fazer logout:", error);
    }
  };

  if (loading) {
    console.log("Carregando informações...");
    return (
      <div className="portal-container">
        <p>Verificando autenticação...</p>
      </div>
    );
  }

  console.log("Preparando o Portal para exibição");

  return (
    <>
      <Header>
        <Navbar />
      </Header>
      <div className="portal-container">
        {user ? (
          <div className="portal-layout">
            <Sidebar
              onNavigate={navigateTo}
              onLogout={handleLogout}
              isSidebarOpen={isSidebarOpen}
              toggleSidebar={toggleSidebar}
            />
            <main className="content">{renderContent}</main>
          </div>
        ) : (
          <Login onLogin={handleLogin} />
        )}
      </div>

            {/* 🔹 Chatbot MercIA como botão flutuante */}
            <MerciaChat />


    </>
  );
};

export default Portal;
